class MeasuringGuide extends HTMLElement {
  connectedCallback() {
    this._details = Array.from(this.querySelectorAll('.measuring-guide__row'));
    this._images = Array.from(this.querySelectorAll('.measuring-guide__image'));
    this._sizeText = this.querySelector('.measuring-guide__size-text');
    this._sizeSelect = this.querySelector('.measuring-guide__size-select');
    this._activeDetail = null;

    this._details.forEach((detail) => {
      const summary = detail.querySelector('summary');
      if (!summary) return;
      summary.addEventListener('click', (event) => {
        event.preventDefault();
        this._toggle(detail);
      });
    });

    this.addEventListener('click', (event) => {
      const unitButton = event.target.closest('.measuring-guide__unit-btn');
      if (unitButton) this._setUnit(unitButton);
    });

    if (this._sizeSelect) {
      this._sizeSelect.addEventListener('change', () => this._updateSizeText());
    }

    const initialOpen = this._details.find((detail) => detail.open) || this._details[0];
    if (initialOpen) this._setActiveRow(initialOpen);
  }

  _toggle(detail) {
    const body = detail.querySelector('.pia__body');
    if (!body) return;

    if (detail.open) {
      this._collapse(detail, body);
      return;
    }

    this._details.forEach((d) => {
      if (d !== detail && d.open) this._collapse(d, d.querySelector('.pia__body'));
    });

    this._expand(detail, body);
    this._setActiveRow(detail);
  }

  _expand(detail, body) {
    body.getAnimations().forEach((a) => a.cancel());
    detail.open = true;
    const height = body.scrollHeight;
    body.animate(
      [{ height: '0px', opacity: '0' }, { height: `${height}px`, opacity: '1' }],
      { duration: 320, easing: 'ease-out' }
    );
  }

  _collapse(detail, body) {
    body.getAnimations().forEach((a) => a.cancel());
    const height = body.scrollHeight;
    const anim = body.animate(
      [{ height: `${height}px`, opacity: '1' }, { height: '0px', opacity: '0' }],
      { duration: 280, easing: 'ease-in', fill: 'forwards' }
    );
    anim.onfinish = () => {
      detail.open = false;
      anim.cancel();
    };
  }

  _setActiveRow(detail) {
    this._activeDetail = detail;
    const index = detail.dataset.index;
    this._images.forEach((image) => {
      image.classList.toggle('--active', image.dataset.index === index);
    });
    this._updateSizeText();
  }

  _setUnit(button) {
    const unit = button.dataset.unit;
    if (!unit || unit === this.dataset.unit) return;

    this.dataset.unit = unit;
    this.querySelectorAll('.measuring-guide__unit-btn').forEach((btn) => {
      btn.classList.toggle('--active', btn.dataset.unit === unit);
    });
    this._updateSizeText();
  }

  _updateSizeText() {
    if (!this._sizeText) return;

    const detail = this._activeDetail;
    const size = this._sizeSelect ? this._sizeSelect.value : '';
    const raw = detail && size ? detail.dataset[`size${size}`] : '';

    if (!raw) {
      this._sizeText.textContent = '';
      return;
    }

    const unitIndex = this.dataset.unit === 'in' ? 1 : 0;
    const parts = raw.split('|');
    const text = (parts[unitIndex] || parts[0] || '').trim();
    this._sizeText.textContent = text;
  }
}

if (!customElements.get('measuring-guide')) {
  customElements.define('measuring-guide', MeasuringGuide);
}
